import { render, staticRenderFns } from "./ConfigPanelContextMenuComponent.vue?vue&type=template&id=3fd36714&scoped=true"
import script from "./ConfigPanelContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfigPanelContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConfigPanelContextMenuComponent.vue?vue&type=style&index=0&id=3fd36714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd36714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd36714')) {
      api.createRecord('3fd36714', component.options)
    } else {
      api.reload('3fd36714', component.options)
    }
    module.hot.accept("./ConfigPanelContextMenuComponent.vue?vue&type=template&id=3fd36714&scoped=true", function () {
      api.rerender('3fd36714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/AppBarToolbarItems/contextMenus/ConfigPanelContextMenuComponent.vue"
export default component.exports